import { GuidService } from 'ui-components/services/guid-service';

import { BEGIN_OPTIMISTIC_UPDATE, COMMIT_OPTIMISTIC_UPDATE, REVERT_OPTIMISTIC_UPDATE } from '../optimistic.update.reducer';

export const GET_ORDERS_REQUEST = 'GET_ORDERS_REQUEST';
export const GET_ORDERS_SUCCESS = 'GET_ORDERS_SUCCESS';
export const GET_ORDERS_FAILURE = 'GET_ORDERS_FAILURE';
export const CLEAR_GET_ORDERS_FAILURE = 'CLEAR_GET_ORDERS_FAILURE';
export const GET_ORDERS_COUNTS = 'GET_ORDERS_COUNTS';
export const GET_SILENT_ORDERS_REQUEST = 'GET_SILENT_ORDERS_REQUEST';
export const MARK_PAID_SUCCESS = 'MARK_PAID_SUCCESS';
export const CREATE_ORDER_REQUEST = 'CREATE_ORDER_REQUEST';
export const CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS';
export const CREATE_ORDER_FAILURE = 'CREATE_ORDER_FAILURE';
export const UPDATE_ORDER_SUCCESS = 'UPDATE_ORDER_SUCCESS';
export const ADD_TAGS_TO_FULFILLMENT_PLANS = 'ADD_TAGS_TO_FULFILLMENT_PLANS';
export const REMOVE_TAGS_FROM_FULFILLMENT_PLANS = 'REMOVE_TAGS_FROM_FULFILLMENT_PLANS';
export const CANCEL_BULK_ORDER_REQUEST = 'CANCEL_BULK_ORDER_REQUEST';
export const CANCEL_BULK_ORDER_SUCCESS = 'CANCEL_BULK_ORDER_SUCCESS';
export const UPDATE_BULK_CANCEL_JOB = 'UPDATE_BULK_CANCEL_JOB';
export const DELETE_BULK_CANCEL_JOB = 'DELETE_BULK_CANCEL_JOB';
export const BULK_CANCEL_JOB_COMPLETE = 'BULK_CANCEL_JOB_COMPLETE';
export const RESTORE_ORDER_REQUEST = 'RESTORE_ORDER_REQUEST';
export const RESTORE_ORDER_SUCCESS = 'RESTORE_ORDER_SUCCESS';
export const RESTORE_FULFILLMENTS_REQUEST = 'RESTORE_FULFILLMENTS_REQUEST';
export const RESTORE_FULFILLMENTS_SUCCESS = 'RESTORE_FULFILLMENTS_SUCCESS';

export const ORDERS_PURCHASE_BULK_LABELS = 'ORDERS_PURCHASE_BULK_LABELS';

export const ORDERS_BULK_DIRECT_PRINT_LABEL = 'ORDERS_BULK_DIRECT_PRINT_LABEL';
export const ORDERS_BULK_DOWNLOAD_LABEL = 'ORDERS_BULK_DOWNLOAD_LABEL';
export const ORDERS_BULK_PRINT_PACKING_SLIPS = 'ORDERS_BULK_PRINT_PACKING_SLIPS';
export const ORDERS_BULK_DIRECT_PRINT_PACKING_SLIPS = 'ORDERS_BULK_DIRECT_PRINT_PACKING_SLIPS';
export const ORDERS_BULK_DOWNLOAD_PACKING_SLIPS = 'ORDERS_BULK_DOWNLOAD_PACKING_SLIPS';

export const QUICK_SEARCH_ORDERS_SUCCESS = 'QUICK_SEARCH_ORDERS_SUCCESS';

export const SET_HOLD_UNTIL_DATE_REQUEST = 'SET_HOLD_UNTIL_DATE_REQUEST';
export const SET_HOLD_UNTIL_DATE_SUCCESS = 'SET_HOLD_UNTIL_DATE_SUCCESS';
export const SET_HOLD_UNTIL_DATE_FAILURE = 'SET_HOLD_UNTIL_DATE_FAILURE';

export const ASSIGN_BULK_FULFILLMENT_PLAN_FROM_ORDERS_GRID = 'ASSIGN_BULK_FULFILLMENT_PLAN_FROM_ORDERS_GRID';
export const ASSIGN_BULK_FULFILLMENT_PLAN_FROM_ORDERS_GRID_SUCCESS = 'ASSIGN_BULK_FULFILLMENT_PLAN_FROM_ORDERS_GRID_SUCCESS';

export const OPEN_FULFILLMENT_PLAN_ASSIGNMENT_MODAL = 'OPEN_FULFILLMENT_PLAN_ASSIGNMENT_MODAL';

export const OPEN_MARK_AS_PAID_MODAL = 'OPEN_MARK_AS_PAID_MODAL';

export const requestGetOrders = () => {
  return {
    type: GET_ORDERS_REQUEST,
  };
};

export const silentRequestGetOrders = () => {
  return {
    type: GET_SILENT_ORDERS_REQUEST,
  };
};

export const getOrdersSuccess = (orders, page, pageSize, totalCount) => ({
  orders,
  page,
  pageSize,
  totalCount,
  type: GET_ORDERS_SUCCESS,
});

export const getOrdersCounts = () => ({
  type: GET_ORDERS_COUNTS,
});

export const getOrdersFailure = (error) => ({
  type: GET_ORDERS_FAILURE,
  error,
});

export const clearGetOrdersFailure = () => ({
  type: CLEAR_GET_ORDERS_FAILURE,
});

export const purchaseBulkLabels = (andPrint, fulfillmentPlanIds = [], skipAmazonShipmentCheck = false) => ({
  type: ORDERS_PURCHASE_BULK_LABELS,
  andPrint,
  fulfillmentPlanIds,
  skipAmazonShipmentCheck,
});

export const addTagsToFulfillmentPlans = (fulfillmentPlanIds, tagIds) => ({
  type: ADD_TAGS_TO_FULFILLMENT_PLANS,
  fulfillmentPlanIds,
  tagIds,
});

export const removeTagsFromFulfillmentPlans = (fulfillmentPlanIds, tagIds) => ({
  type: REMOVE_TAGS_FROM_FULFILLMENT_PLANS,
  fulfillmentPlanIds,
  tagIds,
});

export const createOrder = (order, redirect, workflowGuid) => {
  return {
    type: CREATE_ORDER_REQUEST,
    order,
    redirect,
    workflowGuid,
  };
};

export const createOrderSuccess = (order, redirect, workflowGuid) => {
  return {
    type: CREATE_ORDER_SUCCESS,
    order,
    redirect,
    workflowGuid,
  };
};

export const createOrderFailure = (response, errorMessage, workflowGuid) => {
  return {
    type: CREATE_ORDER_FAILURE,
    response,
    errorMessage,
    workflowGuid,
  };
};

export const markPaidSuccess = (salesOrderId) => {
  return {
    type: MARK_PAID_SUCCESS,
    salesOrderId,
  };
};

export const requestRestoreOrder = (salesOrderId) => {
  return {
    type: RESTORE_ORDER_REQUEST,
    salesOrderId,
  };
};

export const restoreOrderSuccess = (salesOrderIds) => {
  return {
    type: RESTORE_ORDER_SUCCESS,
    salesOrderIds,
  };
};

export const requestRestoreFulfillments = (fulfillmentPlanId) => {
  return {
    type: RESTORE_FULFILLMENTS_REQUEST,
    fulfillmentPlanId,
  };
};

export const restoreFulfillmentsSuccess = (fulfillmentPlanId) => {
  return {
    type: RESTORE_FULFILLMENTS_SUCCESS,
    fulfillmentPlanId,
  };
};

export const quickSearchOrdersSuccess = ({ results, statusListByStore }) => ({
  type: QUICK_SEARCH_ORDERS_SUCCESS,
  ...results,
  statusListByStore,
});

export const setHoldUntilDate = (fulfillmentPlanIds, holdUntilDateTime) => {
  const optimisticId = GuidService.newGuid();
  return {
    type: SET_HOLD_UNTIL_DATE_REQUEST,
    payload: {
      fulfillmentPlanIds,
      holdUntilDateTime,
    },
    meta: {
      optimistic: BEGIN_OPTIMISTIC_UPDATE,
      optimisticId,
      onSuccess: () => ({
        type: SET_HOLD_UNTIL_DATE_SUCCESS,
        meta: {
          optimistic: COMMIT_OPTIMISTIC_UPDATE,
          optimisticId,
        },
      }),
      onError: (error) => ({
        type: SET_HOLD_UNTIL_DATE_FAILURE,
        payload: new Error(error),
        error: true,
        meta: {
          optimistic: REVERT_OPTIMISTIC_UPDATE,
          optimisticId,
        },
      }),
    },
  };
};

export const assignBulkFulfillmentPlanToUserFromOrdersGrid = (fulfillmentPlanIds, userId) => ({
  type: ASSIGN_BULK_FULFILLMENT_PLAN_FROM_ORDERS_GRID,
  fulfillmentPlanIds,
  userId,
});
export const assignBulkFulfillmentPlanToUserFromOrdersGridSuccess = () => ({
  type: ASSIGN_BULK_FULFILLMENT_PLAN_FROM_ORDERS_GRID_SUCCESS,
});

export const OPTIMISTIC_ASSIGN_FULFILLMENT_PLAN_FROM_ORDERS_GRID = 'OPTIMISTIC_ASSIGN_FULFILLMENT_PLAN_FROM_ORDERS_GRID';
export const OPTIMISTIC_ASSIGN_FULFILLMENT_PLAN_FROM_ORDERS_GRID_SUCCESS = 'OPTIMISTIC_ASSIGN_FULFILLMENT_PLAN_FROM_ORDERS_GRID_SUCCESS';
export const OPTIMISTIC_ASSIGN_FULFILLMENT_PLAN_FROM_ORDERS_GRID_FAILURE = 'OPTIMISTIC_ASSIGN_FULFILLMENT_PLAN_FROM_ORDERS_GRID_FAILURE';

export const optimisticAssignFulfillmentPlanToUserFromOrdersGrid = (fulfillmentPlanId, userId) => {
  const optimisticId = GuidService.newGuid();
  return {
    type: OPTIMISTIC_ASSIGN_FULFILLMENT_PLAN_FROM_ORDERS_GRID,
    payload: {
      fulfillmentPlanId,
      userId,
    },
    meta: {
      optimistic: BEGIN_OPTIMISTIC_UPDATE,
      optimisticId,
      onSuccess: () => ({
        type: OPTIMISTIC_ASSIGN_FULFILLMENT_PLAN_FROM_ORDERS_GRID_SUCCESS,
        meta: {
          optimistic: COMMIT_OPTIMISTIC_UPDATE,
          optimisticId,
        },
      }),
      onError: (error) => ({
        type: OPTIMISTIC_ASSIGN_FULFILLMENT_PLAN_FROM_ORDERS_GRID_FAILURE,
        payload: new Error(error),
        error: true,
        meta: {
          optimistic: REVERT_OPTIMISTIC_UPDATE,
          optimisticId,
        },
      }),
    },
  };
};

export const bulkLabelDirectPrint = () => ({
  type: ORDERS_BULK_DIRECT_PRINT_LABEL,
});
export const bulkLabelDownload = () => ({ type: ORDERS_BULK_DOWNLOAD_LABEL });
export const bulkPackingSlipsPrint = (autoPrint) => ({
  type: ORDERS_BULK_PRINT_PACKING_SLIPS,
  autoPrint,
});
export const bulkPackingSlipsDirectPrint = () => ({
  type: ORDERS_BULK_DIRECT_PRINT_PACKING_SLIPS,
});
export const bulkPackingSlipsDownload = () => ({
  type: ORDERS_BULK_DOWNLOAD_PACKING_SLIPS,
});

export const requestBulkCancelOrder = (salesOrderIds, notificationId, shouldVoidFulfillments = false) => {
  return {
    type: CANCEL_BULK_ORDER_REQUEST,
    salesOrderIds,
    notificationId,
    shouldVoidFulfillments,
  };
};

export const bulkCancelOrderSuccess = (salesOrderId) => {
  return {
    type: CANCEL_BULK_ORDER_SUCCESS,
    salesOrderId,
  };
};

export const updateBulkCancelJob = (bulkCancelJobId, pusherJobGuids, notificationId) => {
  return {
    type: UPDATE_BULK_CANCEL_JOB,
    bulkCancelJobId,
    pusherJobGuids,
    notificationId,
  };
};

export const bulkCancelJobComplete = (pusherJobGuid, data) => ({
  type: BULK_CANCEL_JOB_COMPLETE,
  pusherJobGuid,
  data,
});

export const deleteBulkCancelJob = (bulkCancelJobId) => ({
  type: DELETE_BULK_CANCEL_JOB,
  bulkCancelJobId,
});

export const openMarkAsPaidModal = (salesOrderId) => ({
  type: OPEN_MARK_AS_PAID_MODAL,
  salesOrderId,
});

export const OPEN_SCAN_TO_SEARCH_MODAL = 'OPEN_SCAN_TO_SEARCH_MODAL';
export const openScanToSearchModal = () => ({
  type: OPEN_SCAN_TO_SEARCH_MODAL,
});
